import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export const Message404 = styled.h1`
  font-size: 42px;
  color: ${(props) => props.theme.colors.primary};
`;
